<template lang='pug'>
  .landing-page-designer
    page_header(
      :is_preview='show_preview'
      :is_autosaving='is_autosaving'
      :unicorn_mode='unicorn_mode'
      @increase_help_click_count='increase_help_click_count'
      @toggle_preview='toggle_preview')
    studio(
      v-if='show_studio'
      :unicorn_mode='unicorn_mode'
      :shares='enabled_shares'
      :selected_share_id='selected_share_id'
      @save_initialized='save_initialized'
      @change_selected_share='change_selected_share'
      )
    preview(
      v-if='show_preview'
      :shares='enabled_shares'
      :selected_share_id='selected_share_id'
      @change_selected_share='change_selected_share'
      @toggle_preview='toggle_preview')
    div(
      data-pp-cfiw-widget='7118587c-bdcc-11e8-9e09-06df22ffaf6f'
      data-env='prod'
      data-static='false'
    )
</template>

<script>
  import axios from 'axios'
  import preview from './preview.vue'
  import studio from './studio.vue'
  import templates from './templates.vue'
  import add_font_dom from '../utils/add_font_dom'
  import page_header from './header.vue'
  import { db, api_base_path, auth } from '../utils/firebase'

  export default {
    name: 'landing_page_designer',
    components: {
      templates,
      page_header,
      studio,
      preview,
    },
    $_veeValidate: {
      validator: 'new' // give me my own validator scope.
    },
    data() {
      return {
        is_autosaving: false,
        show_studio: true,
        help_click_count: 0,
        shares: [],
        selected_share_id: ''
      }
    },
    firestore() {
      return {
        shares: db.collection(`brands/${this.brand_id}/campaigns/${this.campaign_id}/share_settings`)
      }
    },
    computed: {
      enabled_shares() {
        return _.filter(this.shares, share => share.responsive_share_image_url !== '/share_images/medium/missing.png')
      },
      campaign_id() {
        return this.$route.params.campaign_id
      },
      brand_id() {
        return this.$route.params.brand_id
      },
      show_preview() {
        return !this.show_studio
      },
      unicorn_mode() {
        return this.help_click_count >= 5
      }
    },
    methods: {
      save_initialized() {
        this.is_autosaving = true
        window.setTimeout(()=> this.is_autosaving = false, 3000)
      },
      increase_help_click_count() {
        this.help_click_count++
      },
      toggle_preview(show_preview) {
        this.show_studio = !show_preview
      },
      change_selected_share(share_id) {
        this.selected_share_id = share_id
      }
    },
    watch: {
      shares() {
        this.selected_share_id = this.shares[0] ? this.shares[0].id : ''
      }
    },
    async mounted() {
      let brand = await db.doc(`brands/${this.$route.params.brand_id}`).get()
      brand = brand.data()

      // Get uploaded fonts and add them to the DOM
      const custom_fonts = brand.custom_fonts
      if (custom_fonts) {
        custom_fonts.forEach(font => add_font_dom(font))
      }

      // Get google fonts add add them to the DOM
      let google_fonts = brand.fonts
      if (google_fonts) {
        google_fonts = google_fonts.map(font => font.family)
        WebFont.load({
          google: {
            families: google_fonts
          }
        });
      }

      const id = 'prodpad-cfiwjs'
      const head = document.getElementsByTagName("head")[0]

      if (document.getElementById(id)) return;
      const script = document.createElement("script");
      script.id = id
      script.src="https://widget.prodpad.com/customer_feedback_portal_app/inapp_widget/sdk.js";
      head.appendChild(script)
    }
  }
</script>

<style lang='scss'>
</style>
